export default "__VITE_ASSET__BP6a6Wd5__"